var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.3 24 11.3-11.5L24 24zM0 0h12L0 12.5zm13.4 0L0 14v10l12-12L24 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.6f50c840179062e77bc66234717abc46.svg";
export { ForwardRef as ReactComponent };